import { render, staticRenderFns } from "./OpportunityNotes.vue?vue&type=template&id=45c0a1b0&scoped=true&"
import script from "./OpportunityNotes.vue?vue&type=script&lang=js&"
export * from "./OpportunityNotes.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityNotes.vue?vue&type=style&index=0&id=45c0a1b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c0a1b0",
  null
  
)

export default component.exports